module.exports = __webpack_public_path__ + "static/media/bookmark-empty.5c422702.svg";